export default "__VITE_ASSET__CHaoy6EL__"